<template>
  <t-select
    ref="select"
    :disabled="disabled"
    :placeholder="placeholder"
    :size="size"
    :placement="placement"
    :remote-method="$_remoteMethod"
    filterable
    remote
    auto-complete
    @on-change="$_handleChange">
    <slot name="input">
      <t-input
        ref="input"
        slot="input"
        v-model="currentValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :size="size"
        :icon="icon"
        :icon-placement="iconPlacement"
        @on-focus="$_handleFocus"
        @on-blur="$_handleBlur"></t-input>
    </slot>
    <slot>
      <t-option v-for="item in filteredData" :value="item" :key="item">{{ item }}</t-option>
    </slot>
  </t-select>
</template>
<script>
import TSelect from '../select/select.vue'
import TOption from '../select/option.vue'
import TInput from '../input/input.vue'
import Emitter from '../../mixins/emitter'

export default {
  name: 'TAutoComplete',
  components: {TSelect, TOption, TInput},
  mixins: [Emitter],
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    size: {
      type: String,
      validator (value) {
        return ['sm', 'lg', 'default'].includes(value)
      }
    },
    icon: {
      type: String
    },
    iconPlacement: {
      type: String,
      validator (value) {
        return ['left', 'right'].includes(value)
      }
    },
    filterMethod: {
      type: [Function, Boolean],
      default: false
    },
    placement: {
      type: String,
      validator (value) {
        return [ 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end' ].includes(value)
      },
      default: 'bottom-start'
    }
  },
  data () {
    return {
      currentValue: this.value,
      disableEmitChange: false
    }
  },
  computed: {
    filteredData () {
      if (this.filterMethod) {
        return this.data.filter(item => this.filterMethod(this.currentValue, item))
      } else {
        return this.data
      }
    }
  },
  watch: {
    value (val) {
      this.disableEmitChange = true
      this.currentValue = val
    },
    currentValue (val) {
      this.$refs.select.query = val
      this.$emit('input', val)
      if (this.disableEmitChange) {
        this.disableEmitChange = false
        return
      }
      this.$emit('on-change', val)
      this.dispatch('TFormItem', 'on-form-change', val)
    }
  },
  methods: {
    $_remoteMethod (query) {
      this.$emit('on-search', query)
    },
    $_handleChange (val) {
      this.currentValue = val
      this.$refs.select.model = val
      this.$refs['input'].blur()
      this.$emit('on-select', val)
    },
    $_handleFocus () {
      this.$refs.select.visible = true
    },
    $_handleBlur () {
      this.$refs.select.visible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// auto-complete.vue?58064089